const AssetReporting = {
  search: (params, page = 1) => ({ url: '/reporting/assets/searches/new', params: { q: params, page: page } }),
  export: (params = {}) => ({ url: '/reporting/assets/searches/export', params: { q: params } }),
  infoFields: () => ({ url: '/reporting/assets/searches/searchable_attributes' }),
};

export default AssetReporting;
